import type { SVGProps } from "react"

export const GridIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" {...props}>
    <path d="M4 14.5V10l8-6 8 6v4.5" strokeWidth="1.75" strokeLinejoin="round" />
    <path d="M8 22V14h8v8" strokeWidth="1.75" />
    <path d="M2 22h20" strokeWidth="1.75" strokeLinecap="round" />
    <path d="M12 10v4" strokeWidth="1.75" />
  </svg>
)
